import { createFileRoute, retainSearchParams } from "@tanstack/react-router"
import { z } from "zod"

import { ProductPurchaseCostsContainer } from "@/screens/Products/components/Product/Costs"

const productPurchaseCostsSearchSchema = z.object({})

export const PRODUCT_COSTS_PURCHASE_COSTS_ROUTE_PATH =
  "/app/product/$productId/edit/_layout/costs/_layout/purchase-costs"

export const Route = createFileRoute(PRODUCT_COSTS_PURCHASE_COSTS_ROUTE_PATH)({
  validateSearch: productPurchaseCostsSearchSchema,
  search: {
    middlewares: [retainSearchParams([])],
  },
  component: ProductPurchaseCostsContainer,
})
